export default __webpack_public_path__ + "static/media/pic7.e1258dc4.jpg";